import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';
import logo from '../assets/img/logo2.png';
import LanguageSwitcher from '../components/LanguageSwitcher';
import { useTranslation } from '../i18n';

const Home = () => {
  const { t } = useTranslation();

  const isLoggedIn = !!localStorage.getItem('userRole');
  const communityTarget = isLoggedIn ? '/social' : '/login?redirect=/social';

  return (
    <div className="home-root">
      <div className="home-overlay" />

      <div className="home-container">
        <div className="home-language-switcher">
          <LanguageSwitcher />
        </div>

        <main className="home-main">
          <img src={logo} alt="Tzone" className="home-logo" />

          <p className="home-subtitle">
            {t('home.subtitle')}
          </p>

          <div className="home-buttons">
            <Link to="/login">
              <button className="btn-login">{t('home.enter')}</button>
            </Link>

            <Link to="/register">
              <button className="btn-register">{t('home.register')}</button>
            </Link>

            <Link to={communityTarget}>
              <button className="btn-community">{t('home.community')}</button>
            </Link>
          </div>
        </main>

        <footer className="home-footer">
          <div className="home-footer-line">
            {t('home.companyPrefix')} ·{' '}
            <a href="mailto:contacto@tzone.run">contacto@tzone.run</a>
          </div>

          <div className="home-legal-links">
            <Link to="/legal/privacidad">{t('home.privacyPolicyEs')}</Link>
            <span>·</span>
            <Link to="/legal/privacy">{t('home.privacyPolicyEn')}</Link>
            <span>·</span>
            <Link to="/legal/aviso-metricas">{t('home.metricsNotice')}</Link>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default Home;